import React from "react";
import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Mail, ArrowUpRight, Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative mt-32 border-t border-white/5 bg-[#050505]">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#00F0FF]/60 to-transparent" />

      {/* Giant CTA */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-12">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#0a0a0c] via-[#0a0a10] to-[#0a0a0c] p-10 md:p-16">
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#00F0FF]/10 blur-3xl" />
          <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#FF00FF]/10 blur-3xl" />
          <div className="relative z-10 flex flex-col md:flex-row gap-8 items-start md:items-center justify-between">
            <div>
              <div className="tag-chip mb-4">Let's Build</div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-balance">
                Got a wild idea?<br/>
                <span className="gradient-text">We'll make it real.</span>
              </h2>
            </div>
            <Link to="/contact" data-testid="footer-cta" className="btn-primary !px-8 !py-4 !text-base group">
              Start a Project
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pb-10 border-b border-white/5">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#00F0FF] to-[#FF00FF] flex items-center justify-center">
                <Zap className="w-5 h-5 text-black" strokeWidth={3} />
              </div>
              <div className="font-display font-black text-lg">SPIN<span className="text-[#00F0FF]">.</span>LABS</div>
            </div>
            <p className="text-sm text-white/60 max-w-sm leading-relaxed">
              We design, build, and scale intelligent software products. From first line of code to global launch.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[{i:Twitter,href:"#"},{i:Linkedin,href:"#"},{i:Github,href:"#"},{i:Mail,href:"mailto:info@spinlabs.in"}].map((s, idx) => (
                <a key={idx} href={s.href} className="w-10 h-10 rounded-full border border-white/10 hover:border-[#00F0FF] hover:text-[#00F0FF] flex items-center justify-center text-white/70 transition-all">
                  <s.i className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-mono-neo text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-[#00F0FF]">About</Link></li>
              <li><Link to="/work" className="text-white/70 hover:text-[#00F0FF]">Case Studies</Link></li>
              <li><Link to="/insights" className="text-white/70 hover:text-[#00F0FF]">Insights</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-[#00F0FF]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-mono-neo text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="text-white/70 hover:text-[#00F0FF]">Mobile Apps</Link></li>
              <li><Link to="/services" className="text-white/70 hover:text-[#00F0FF]">AI Websites</Link></li>
              <li><Link to="/services" className="text-white/70 hover:text-[#00F0FF]">Custom AI</Link></li>
              <li><Link to="/services" className="text-white/70 hover:text-[#00F0FF]">SaaS Platforms</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-mono-neo text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li className="text-white/70">info@spinlabs.in</li>
              <li className="text-white/70">Delhi, IN · Remote</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs font-mono-neo">
          <div className="text-white/40">© {new Date().getFullYear()} Spin Labs. All rights reserved.</div>
          <div className="text-white/40 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#39FF14] animate-pulse" />
            SYSTEM ONLINE · v1.0
          </div>
        </div>
      </div>
    </footer>
  );
}
